module.exports = __webpack_public_path__ + "static/media/smog.a9a45ed2.svg";